import { ApprovalsQueuePage } from "@/components/plans/ApprovalsQueuePage";
import { PageContainer } from "@/components/shared/PageContainer";
import { PageHeader } from "@/components/shared/PageHeader";
import { ProtectedContentNotice } from "@/components/shared/ViewOnlyGate";
import { useCan } from "@/hooks/use-can";

export function DashboardPlanApprovalsPage() {
  // The page is open to every role (product decision 2026-10-08), but every approval row
  // carries a shortfall in dollars (RP-17.1), which only `viewPlanCost` holders may see —
  // so everyone else gets a short explanation instead of the queue.
  const canViewCost = useCan("viewPlanCost");
  if (canViewCost) return <ApprovalsQueuePage />;
  return (
    <PageContainer>
      <PageHeader
        eyebrow="Manage"
        title="Plan Approvals"
        description="Plans waiting on a Finance or Admin decision."
      />
      <ProtectedContentNotice>
        Approval requests include cost and margin figures, so only Finance, Resource Managers and
        Admins can see the queue. You can still follow an approval's status and reason on the plan
        itself.
      </ProtectedContentNotice>
    </PageContainer>
  );
}
